import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/axios';
import { useSearchParams } from "react-router-dom";

function Kelas() {
  const navigate = useNavigate();
  const [kelas, setKelas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchParams] = useSearchParams();
  const m = searchParams.get("m");

  const [kelasId, setKelasId] = useState('');

  // Get logged-in member data
  const member = JSON.parse(localStorage.getItem('member_user') || 'null');
  const isLoggedIn = !!member;

  const [formData, setFormData] = useState({
    nama: member?.name || '',
    hp: member?.phone || ''
  });

  const [accountExists, setAccountExists] = useState(null);

  useEffect(() => {
    const fetchKelas = async () => {
      try {
        const response = await api.get(`/api/webinars`);
        setKelas(response.data);
      } catch (err) {
        setError('Gagal memuat daftar kelas.');
        console.error('Error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchKelas();
  }, []);

  const handleChange = (e) => {
    let value = e.target.value;
    if (e.target.name === 'hp') {
      value = value.replace(/[^0-9]/g, '');
    }
    setFormData({
      ...formData,
      [e.target.name]: value
    });
  };

  const normalizePhone = (phone) => {
    let p = phone.replace(/[^0-9]/g, '');
    if (p.startsWith('0')) {
      p = '62' + p.slice(1);
    } else if (!p.startsWith('62')) {
      p = '62' + p;
    }
    return p;
  };

  const validatePhone = (phone) => {
    return /^628\d{7,13}$/.test(normalizePhone(phone));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const selectedKelas = kelas.find(w => w.id == kelasId);
    if (!selectedKelas) {
      alert('Silakan pilih kelas.');
      return;
    }

    if (!isLoggedIn) {
      if (!formData.nama.trim()) {
        alert('Nama wajib diisi.');
        return;
      }
      if (!validatePhone(formData.hp)) {
        alert('Nomor HP wajib diisi dengan format 08xxxxxxxxxx (contoh: 081234567890).');
        return;
      }

      // Cek apakah nomor HP sudah punya akun
      try {
        const checkRes = await api.post('/api/member/check', { phone: normalizePhone(formData.hp) });
        if (checkRes.data?.exists) {
          setAccountExists(formData.hp);
          return;
        }
      } catch (checkErr) {
        console.error('Error checking phone:', checkErr);
      }
    }

    const idtransaction = 'conexsee-' + Math.random().toString(36).substring(2, 15);

    const storedHp = isLoggedIn ? formData.hp : normalizePhone(formData.hp);

    const paymentData = {
      name: formData.nama,
      number: storedHp,
      status: 'Umum',
      webinar_id: kelasId,
      transaction_id: idtransaction,
      member_id: isLoggedIn ? (member.id || m) : null
    };

    if (selectedKelas.price > 0) {
      try {
        await api.post('/api/webinar-payments', paymentData);

        navigate(`/webinar/redirect/${idtransaction}`, {
          state: {
            formData: {
              nama: formData.nama,
              hp: storedHp,
              status: 'Umum',
              kelas_id: kelasId,
              member_id: paymentData.member_id
            },
            selectedWebinar: selectedKelas
          }
        });

      } catch (backendErr) {
        console.error('Error:', backendErr);
        alert('Gagal menyimpan data pendaftaran');
      }

    } else {
      console.log('Pendaftaran kelas gratis');
      alert('Pendaftaran berhasil!');
    }
  };

  const formatRupiah = (number) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0
    }).format(number);
  };

  const discountAffliate = m != null ? 5000 : 0;
  let selectedPrice =
    (kelas.find(w => w.id == kelasId)?.price || 0) - discountAffliate;
  if (selectedPrice < 0) {
    selectedPrice = 0;
  }

  if (loading) {
    return <div className="container mt-4">Memuat daftar kelas...</div>;
  }

  if (error) {
    return <div className="container mt-4" style={{ color: 'red' }}>{error}</div>;
  }

  return (
    <div className="container mt-4">
      <h2>Form Pendaftaran Kelas</h2>
      <img className="img-fluid" src="https://akad.in/storage/images/rsTxkoe9AMKHuA3oPCKBGzoc1F7U7zllgGoQ0faz.jpg" alt="Conexsee Logo" />
      <hr />
      <div className="container my-4">
        <div className="ratio ratio-16x9">
          <iframe
            src="https://www.youtube.com/embed/i8oC38YkDyw?autoplay=1&mute=1"
            title="YouTube video player"
            allow="autoplay; accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen>
          </iframe>
        </div>
      </div>
      <hr />

      {isLoggedIn ? (
        <div className="alert alert-info">
          <i className="bi bi-info-circle me-2"></i>
          <strong>Halo, {member.name}!</strong> Anda login sebagai <strong>{member.phone}</strong>.
          Pilih kelas yang ingin Anda ikuti di bawah ini.
        </div>
      ) : null}

      {!isLoggedIn && accountExists && (
        <div className="alert alert-info text-center">
          <i className="bi bi-person-check me-2"></i>
          <strong>Nomor HP {accountExists} sudah terdaftar.</strong>
          <p className="mb-2 mt-1">Anda sudah memiliki akun. Silakan login untuk mendaftar/mengakses kelas.</p>
          <Link to="/login" className="btn btn-dark">Login di Sini</Link>
        </div>
      )}

      {(!isLoggedIn && !accountExists) || isLoggedIn ? (
      <form onSubmit={handleSubmit}>
        {!isLoggedIn && (
          <div className="row mb-3">
            <div className="col-md-6">
              <label htmlFor="nama" className="form-label">Nama Lengkap</label>
              <input
                type="text"
                className="form-control"
                id="nama"
                name="nama"
                value={formData.nama}
                onChange={handleChange}
                placeholder="Masukkan nama lengkap"
                required
              />
            </div>
            <div className="col-md-6">
              <label htmlFor="hp" className="form-label">Nomor HP</label>
              <input
                type="tel"
                className="form-control"
                id="hp"
                name="hp"
                value={formData.hp}
                onChange={handleChange}
                required
                placeholder="081234567890"
              />
              <div className="form-text">Masukkan nomor HP dengan format <strong>08xxxxxxxxxx</strong> (contoh: 081234567890).</div>
            </div>
          </div>
        )}

        <div className="row mb-3">
          <div className="col-md-6">
            <label htmlFor="kelas_id" className="form-label">Pilih Kelas</label>
            <select
              className="form-select"
              id="kelas_id"
              name="kelas_id"
              value={kelasId}
              onChange={(e) => setKelasId(e.target.value)}
              required
            >
              <option value="">Pilih Kelas</option>
              {kelas.length > 0 ? (
                kelas
                  .filter(k => k.type === 'kelas')
                  .map(k => (
                    <option key={k.id} value={k.id}>
                      {k.title}
                    </option>
                  ))
              ) : (
                <option value="">Belum ada kelas tersedia</option>
              )}
            </select>
          </div>
          <div className="col-md-6">
            <label htmlFor="price" className="form-label">Biaya</label>
            <input
              type="text"
              className="form-control"
              id="price"
              value={formatRupiah(selectedPrice)}
              readOnly
            />
          </div>
        </div>

        <button type="submit" className="btn btn-dark mt-3 px-4">Daftar Kelas</button>
      </form>
      ) : null}
    </div>
  );
}

export default Kelas;
